import { QRCodeSVG } from "qrcode.react";
import { createMeetingURL } from "../../../../utils/create-meeting-url";

const baseURL = import.meta.env.VITE_WEBSITE_URL as string;

interface JoinMeetingQRProps {
  meetingId: string
  userId: string
  joinCode: string
  qrCodeSize?: number
}

const JoinMeetingQR: React.FC<JoinMeetingQRProps> = ({
  meetingId,
  userId,
  joinCode,
  qrCodeSize = 200,
}: JoinMeetingQRProps) => {
  const url = createMeetingURL(
    baseURL,
    meetingId,
    userId,
    joinCode,
    undefined,
    "qr"
  );

  return <QRCodeSVG value={url} size={qrCodeSize} />;
};

export default JoinMeetingQR;
